import React from "react";

import AddIcon from "@material-ui/icons/Add";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

import RbActions from "components/RbActions";
import RbButtonAction from "components/RbButtonAction";
import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbHeader from "components/RbHeader";
import RbScrollView from "components/RbScrollView";

import BasicForm from "./BasicForm";
import BasicList from "./BasicList";
import BasicMenu from "./BasicMenu";

function BasicMobile() {
  const history = useHistory();
  const { path } = useRouteMatch();

  const { params: { type } = {} } = useRouteMatch(`${path}/:type`) || {};

  const handleBackList = () => {
    history.push(path);
  };

  const handleBackForm = () => {
    history.push(`${path}/${type}`);
  };

  const handleNew = () => {
    history.push(`${path}/${type}/new`);
  };

  return (
    <Switch>
      <Route path={path} exact>
        <RbFlexView>
          <RbFlexViewItem>
            <RbHeader title="Basic" />
          </RbFlexViewItem>
          <RbFlexViewItem flex={1} bgcolor="custom.bg.100">
            <BasicMenu />
          </RbFlexViewItem>
        </RbFlexView>
      </Route>

      <Route path={`${path}/:type`} exact>
        <RbFlexView>
          <RbFlexViewItem>
            <RbHeader
              title="List"
              onBack={handleBackList}
              actions={
                <RbActions compacted>
                  <RbButtonAction
                    Icon={AddIcon}
                    onClick={handleNew}
                    text="New"
                  />
                </RbActions>
              }
            />
          </RbFlexViewItem>
          <RbFlexViewItem flex={1} bgcolor="custom.bg.100">
            <RbScrollView>
              <BasicList path={path} />
            </RbScrollView>
          </RbFlexViewItem>
        </RbFlexView>
      </Route>

      <Route path={`${path}/:type/:id`} exact>
        <RbFlexView>
          <RbFlexViewItem>
            <RbHeader
              title="Form"
              onBack={handleBackForm}
              actions={
                <RbActions compacted>
                  <RbButtonAction
                    Icon={AddIcon}
                    onClick={handleNew}
                    text="New"
                  />
                </RbActions>
              }
            />
          </RbFlexViewItem>
          <RbFlexViewItem flex={1} bgcolor="custom.bg.100">
            <RbScrollView>
              <BasicForm path={path} />
            </RbScrollView>
          </RbFlexViewItem>
        </RbFlexView>
      </Route>
    </Switch>
  );
}

export default React.memo(BasicMobile);
